var map = {
	"./cinematic-blogger-demo.mp4": 7285,
	"./cv-reviewer-demo.mp4": 4311,
	"./field-visit-demo.mp4": 7161,
	"./neon-board-demo.mp4": 7166,
	"./neural-ai-demo-1.mp4": 5237,
	"./neural-ai-demo-2.mp4": 1042,
	"./prayosha-construction-demo-1.mp4": 6800,
	"./product-gallery-demo.mp4": 7387,
	"./project-management-demo.mp4": 6132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6994;